import React, { Component, Fragment } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import EventSession from './session';
import AddSessionModal from './modals/addSessionModal';
import DeleteSessionModal from './modals/deleteDefaultModal';
import GroupSessionsModal from './modals/groupSessionsModal';
import ViewsContainer from '../../../components/views/ViewsContainer';

let batchActionCB;
class EventSessions extends Component {
	constructor(props) {
		super(props);
		const customFieldColumns = {
			name: 'Name',
			subtitle: 'Subtitle',
			description: 'Description',
			startTime: 'Start Time',
			endTime: 'End Time',
			isAllDay: 'All Day',
			isGeneral: 'Is General',
			locationName: 'Location',
			virtualMeetingType: 'Session Type',
			beoNumber: 'BEO Number',
			setPeople: 'Set (people)',
			guaranteedPeople: 'Guarantee (people)',
			setTime: 'Set Time',
			strikeTime: 'Strike Time',
			roomSet: 'Room Set',
			foodAndBeverage: 'Food and Beverage',
			hotelItemsNeeded: 'Hotel Items Needed',
			avOrder: 'AV Order',
			notes: 'Notes',
			posted: 'Posted on Hotel Agenda',
			virtualMeetingLink: 'Livestream Link',
			recordingLink: 'Recording Link',
			surveyOnly: 'Show only survey',
			displayStartTime: 'Display Start Time',
			displayEndTime: 'Display End Time',
			virtualStartOffset: 'Start Offset',
			virtualStopOffset: 'Stop Offset',
			displayTimezone: 'Display Timezone',
			enableReview: 'Enable Session Review',
			enableSurvey: 'Enable Survey',
			chatEnabled: 'Enable Chat',
			reactionsEnabled: 'Enable Stream Reactions',
			pollsEnabled: 'Enable Polls',
			enable3dOverlays: 'Enable Realtime 3D Effects'
		};
		const defaultFieldTypes = {
			name: 'text',
			subtitle: 'text',
			description: 'text',
			startTime: 'time',
			endTime: 'time',
			isAllDay: 'boolean',
			isGeneral: 'boolean',
			locationName: 'text',
			virtualMeetingType: 'text',
			beoNumber: 'text',
			setPeople: 'number',
			guaranteedPeople: 'number',
			setTime: 'time',
			strikeTime: 'time',
			roomSet: 'text',
			foodAndBeverage: 'text',
			hotelItemsNeeded: 'text',
			avOrder: 'text',
			notes: 'text',
			posted: 'boolean',
			virtualMeetingLink: 'text',
			recordingLink: 'text',
			surveyOnly: 'boolean',
			displayStartTime: 'text',
			displayEndTime: 'text',
			virtualStartOffset: 'text',
			virtualStopOffset: 'text',
			displayTimezone: 'text',
			enableReview: 'boolean',
			enableSurvey: 'boolean',
			chatEnabled: 'boolean',
			reactionsEnabled: 'boolean',
			pollsEnabled: 'boolean',
			enable3dOverlays: 'boolean'
		};
		const fieldCategories = {
			basics: {
				title: 'Basics',
				columns: [
					'name',
					'subtitle',
					'description',
					'startTime',
					'endTime',
					'isAllDay',
					'isGeneral',
					'locationName',
					'virtualMeetingType',
					'beoNumber',
					'setPeople',
					'guaranteedPeople',
					'setTime',
					'strikeTime',
					'roomSet',
					'foodAndBeverage',
					'hotelItemsNeeded',
					'avOrder',
					'notes',
					'posted',
					'virtualMeetingLink',
					'recordingLink',
					'surveyOnly',
					'displayStartTime',
					'displayEndTime',
					'virtualStartOffset',
					'virtualStopOffset',
					'displayTimezone',
					'enableReview',
					'enableSurvey',
					'chatEnabled',
					'reactionsEnabled',
					'pollsEnabled',
					'enable3dOverlays'
				]
			}
		};
		props.customFields.forEach((category) => {
			const fields = category.fields;
			fields.forEach((f) => {
				customFieldColumns[category._id + '*' + f._id] = f.fieldName;
			});
		});

		this.state = {
			categoryColumns: fieldCategories,
			eventId: props.eventId,
			newSessions: [],
			groupSessions: [],
			checkedSessions: {},
			columns: customFieldColumns,
			columnTypes: defaultFieldTypes,
			allChecked: false,
			sessionSelected: false,
			selectedSession: 0,
			searchSelected: false,
			searchTerm: '',
			searchField: '',
			sortByColumn: { name: true },
			addSessionModalOpen: false,
			deleteSessionsModalOpen: false,
			groupSessionsModalOpen: false,
			importSessionsModalOpen: false,
			newSession: {},
			sessionGroup: {},
			loading: false,
			upcomingCount: 0,
			completedCount: 0,
			deletedSessions: [],
			isDeleting: false,
			sidePanelOpen: false,
			editCount: 0,
			activeRow: '',
		};
	}

	addSession = (session, cb) => {
		this.props.addSession(session, () => {
			this.setState({
				editCount: this.state.editCount + 1
			}, () => {
				cb && cb();
			})
		});
	};

	toggleDeleteSessions = (checkedSessions, cb) => {
		batchActionCB = cb;
		this.setState({
			checkedSessions: checkedSessions || this.state.checkedSessions,
			deleteSessionsModalOpen: !this.state.deleteSessionsModalOpen
		});
	};

	deleteCheckedSessions = () => {
		this.props.deleteSessions(Object.keys(this.state.checkedSessions), () => {
			//batchActionCB && batchActionCB('delete');
			this.setState({
				editCount: this.state.editCount + 1
			}, () => {
				batchActionCB && batchActionCB('delete');
				this.toggleDeleteSessions();
				if(this.state.sidePanelOpen){
					this.props.history.push('./');
				}
			});
		});
	};

	deleteSingleSession = (session) => {
		this.props.deleteSessions(Object.keys(session), () => {
			this.setState({
				editCount: this.state.editCount + 1
			}, () => {
				batchActionCB && batchActionCB('delete');
			});
		});
	};

	toggleGroupSessions = (checkedSessions) => {
		this.setState({
			sessionGroup: {},
			checkedSessions: checkedSessions || {},
			groupSessionsModalOpen: !this.state.groupSessionsModalOpen
		});
	};
	groupCheckedSessions = (group, callback) => {
		this.props.groupSessions(group, this.state.checkedSessions, (added) => {
			callback(added);
		});
		this.setState({
			groupSessions: [...this.state.groupSessions, group], loading: false,
			editCount: this.state.editCount + 1
		});
	};

	updateSession = (sessionId, session) => {
		const updatedSessions = this.state.sortedSessions.map((s) => {
			if (sessionId == s.id) {
				session.metadata.forEach((meta) => (session[meta.categoryId + '*' + meta.fieldId] = meta.fieldValue));
				s = { ...s, ...session };
				if (session.location && this.props.venues) {
					const venue = this.props.venues.find(v => v._id == this.props.event.details.venue);
					if (venue && venue.locations) {
						const location = venue.locations.find(l => l._id === session.location);
						s.locationName = location && location.name ? location.name : '';
					}
				} else {
					s.locationName = '';
				}
			}
			return s;
		});
		this.setState({
			sortedSessions: updatedSessions,
			editCount: this.state.editCount + 1
		}, () => {

			this.props.updateSession(sessionId, session)
			this.setState({ editCount: this.state.editCount + 1 })
		});
	};

	toggleAddSession = (cb) => {
		batchActionCB = cb
		this.setState({ addSessionModalOpen: !this.state.addSessionModalOpen });
	};

	saveSession = (session, callback) => {
		this.props.saveSession(session, () => {
			this.setState({ editCount: this.state.editCount + 1 }, () => {
				callback();
			})

		});
	}
	setActiveRow = (sessionId) => {
		this.setState({ activeRow: sessionId })
	}
	render() {
		const {
			eventId,
			selectedSession,
			deleteSessionsModalOpen,
			addSessionModalOpen,
			groupSessionsModalOpen,
			columns,
			isDeleting,
			columnTypes,
			checkedSessions,
			sidePanelOpen,
			editCount,
			categoryColumns,
			activeRow
		} = this.state;

		const { program, sessions, readOnly, sessionsViews, orgId, programId } = this.props;
		const checkedCount = Object.keys(checkedSessions).length;
		return (
			<Switch>
				<Route path={`/${orgId}/programs/${program._id}/schedule`}>
					<Fragment>
						<ViewsContainer
							//key={`sessions${editCount}`}
							activeRow={activeRow}
							categoryColumns={categoryColumns}
							programId={programId}
							orgId={orgId}
							views={sessionsViews}
							entries={sessions}
							columns={columns}
							columnTypes={columnTypes}
							title="Default Event Schedule"
							description="Sessions listed here will be added to all approved events."
							readOnly={false}
							mainActions={[
								{ type: 'button', onClick: this.toggleAddSession, label: 'Add Session' },
							]}
							batchActions={[
								{
									label: 'Delete',
									iconClass: 'las la-trash-alt',
									class: 'danger',
									onClick: this.toggleDeleteSessions
								}
							]}
							enableDownloadViews={true}
							type={'Session'}
							referenceCollection={'Programs'}
							referenceId={program._id}
							breadcrumbs={[
								{
									name: program.name
								}
							]}
						/>
						<DeleteSessionModal
							isOpen={deleteSessionsModalOpen}
							toggle={() => this.toggleDeleteSessions()}
							title={`Delete ${checkedCount > 1 ? 'Sessions' : 'Session'}`}
							message={`You are about to delete ${checkedCount} ${checkedCount > 1
								? 'sessions'
								: 'session'}, this is irreversible,
						would you like to continue?`}
							submit={() =>
								this.deleteCheckedSessions(Object.keys(checkedSessions), () => {
									this.setState({ checkedSessions: {}, deleteSessionsModalOpen: false });
								})}
						/>
						{/*<GroupSessionsModal
							isOpen={groupSessionsModalOpen}
							addGroup={this.groupCheckedSessions}
							toggle={this.toggleGroupSessions}
							groups={this.props.event.groups}
							count={Object.keys(this.state.checkedSessions).length}
						/> */}
						{addSessionModalOpen && <AddSessionModal
							isOpen={addSessionModalOpen}
							handleSubmit={this.addSession}
							toggle={this.toggleAddSession}
							programId={programId}
							orgId={this.props.orgId}
						/>}

						<div className={`sidePanelContainer ${sidePanelOpen ? 'panelOpen' : ''}`}>
							<Switch>
								<Route path={`/:organization/programs/:programId/schedule/:sessionId`}
									render={(props) => {
										const sessionId = props.match.params.sessionId;
										if (!sidePanelOpen) this.setState({ sidePanelOpen: true })
										return <div className='h-100' key={sessionId}>
											<EventSession
												orgId={this.props.orgId}
												program={this.props.program}
												programId={this.state.programId}
												index={selectedSession}
												sessions={sessions}
												readOnly={readOnly}
												customFields={this.props.customFields}
												locations={this.props.locations}
												updateSession={this.updateSession}
												deleteSession={this.deleteSingleSession}
												eventEmails={this.props.eventEmails}
												addNewGroup={this.props.addNewGroup}
												organization={this.props.organization}
												saveSession={this.saveSession}
												setActiveRow={this.setActiveRow}
												venues={this.props.venues}
												event={this.props.event}
												addNewLocation={this.props.addNewLocation}
												renameLocation={this.props.renameLocation}
												deleteLocation={this.props.deleteLocation}
											/>
										</div>
									}}
								>
								</Route>
								<Route exact path={`/:organization/programs/:programId/schedule`}
									render={() => {
										if (sidePanelOpen) this.setState({ sidePanelOpen: false })
										return <></>
									}}
								>
								</Route>
							</Switch>
						</div>
					</Fragment>
				</Route>

			</Switch>
		);
	}
}

export default withRouter(EventSessions);
